import http from "./httpService";
import { apiUrl } from "../config";

export const getCdkOrders = (isDedicated, daysToLookAt) => {
  return http.get(`${apiUrl}CdkOrder/GetCdkOrders`, {
    params: {
      isDedicated,
      daysToLookAt: daysToLookAt * -1,
    },
  });
};

//Max date range on the backend was 7 days last time I checked
export const getCDKOrdersForDateRange = (fromDate, toDate) => {
  return http.get(`${apiUrl}CdkOrder/GetOrderForWeek`, {
    params: { start: fromDate, end: toDate },
  });
};

export const getCDKOrdersByInvoiceList = (invoiceList) => {
  return http.post(`${apiUrl}CdkOrder/GetCdkWithInvoiceNumbers`, {
    invoice: invoiceList,
  });
};

export const getCDKOrdersByCustomerName = (customerNameList) => {
  return http.post(
    `${apiUrl}CdkOrder/GetAllOrdersForCustomer`,
    customerNameList
  );
};

export const getOrderRequestForCdkOrder = (id) => {
  return http.get(`${apiUrl}CdkOrder/GetOrderRequestForCdkOrder`, {
    params: { id },
  });
};

export const postCDKOrder = (orderBody) => {
  return http.post(`${apiUrl}Delivery/PostCdkOrder`, orderBody);
};
export const postMergedCDKOrder = (orderBody) => {
  return http.post(`${apiUrl}CdkOrder/PostCombinedOrder`, orderBody);
};

//Endpoint expects a list of integers in an object with the key Id
export const updateCDKOrderIsImportedField = (orderIdListObject) => {
  return http.post(
    `${apiUrl}CdkOrder/UpdateImportedCdkOrder`,
    orderIdListObject
  );
};

//endDate is not inclusive, you likely want to add 1 day to it.
export const getCdkImportedOrders = (startDate, endDate) => {
  return http.get(`${apiUrl}CdkOrder/GetCdkImportedOrders`, {
    params: { sDate: startDate, eDate: endDate },
  });
};

export const changeCDKOrdersHiddenStatus = (CdkIdList, shouldHide) => {
  return http.post(`${apiUrl}CdkOrder/ChangeHiddenOrders`, {
    CdkIdList: CdkIdList,
    hiddenValue: shouldHide,
  });
};

export const getCDKSearchSuggestionsByInvoiceOrCustomer = (
  isByInvoice,
  searchValue,
  signal
) => {
  return http.get(`${apiUrl}CdkOrder/CdkSearch`, {
    params: {
      flag: isByInvoice,
      searchValue: searchValue,
    },
    signal: signal,
  });
};

export const acceptCDKAgreement = (title, fullname, agreed, signature) => {
  return http.post(`${apiUrl}/CdkOrder/AcceptCdkAgreement`, {
    ClientName: fullname,
    AcceptedDate: new Date(),
    ClientTitle: title,
    Agreement: agreed,
    SignatureImage: signature,
  });
};
export const setSubscriptionPending = (cdkDealerId) => {
  return http.post(`${apiUrl}CdkOrder/SetSubscriptionPending`, {
    DealerId: cdkDealerId,
  });
};

//call this on approval? possibly also api/CdkOrder/FinishEnrollment?
export const sendCDKClientSubscriptionEmailNotification = (
  clientId,
  clientName,
  billCycle,
  dateSubscribed
) => {
  return http.post(`${apiUrl}CdkOrder/CDKClientSubscription`, {
    ClientId: clientId,
    ClientName: clientName,
    BillCycle: billCycle,
    DateSubscribed: dateSubscribed,
  });
};

export const getCDKSubscriptionStatus = () => {
  return http.get(`${apiUrl}CdkOrder/CheckCDKSubscription`);
};
export const getCDKStatusInformation = () => {
  return http.get(`${apiUrl}CdkOrder/GetCdkStatusInformation`);
};

export const setCancellationPending = () => {
  return http.post(`${apiUrl}CdkOrder/SetCancellationPending`);
};

export const getCDKCodDefaultValues = () =>
  http.get(`${apiUrl}CdkOrder/GetCdkCodDefaultValues`);

export const getCDKUniqueCODValues = () =>
  http.get(`${apiUrl}CdkOrder/GetCurrentCodValuesForOrders`);

export const updateCdkCodDefaultSetting = (codValues) =>
  http.post(`${apiUrl}CdkOrder/UpdateCdkCodDefaultValue`, codValues);

export const postNewCdkCodDefaultSetting = (newValues) =>
  http.post(`${apiUrl}CdkOrder/PostCodDefaultValues`, newValues);

export const getCompleteStops = () =>
  http.get(`${apiUrl}CdkOrder/GetCompletedStops`);

export const getCompleteStopByPositionID = (positionLinkId) =>
  http.get(`${apiUrl}CdkOrder/GetCompletedStopDetails`, {
    params: { positionLinkId },
  });
